import { Component, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';

export type ButtonVariant = 'secondary' | 'danger';

@Component({
  selector: 'app-button',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './button.component.html',
  styleUrl: './button.component.scss',
})
export class ButtonComponent {
  /** Button label. */
  label = input.required<string>();
  /** Visual style: secondary (gray) or danger (red). */
  variant = input<ButtonVariant>('secondary');
  /** Optional disabled state. */
  disabled = input<boolean>(false);

  clicked = output<void>();
}
